// extracted by mini-css-extract-plugin
export default {"active":"sidebarItem_active__jb-xI"};